// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-btn--active.no-active:not(:focus):not(:hover):before{opacity:0!important}.v-btn.no-text-transform{text-transform:none!important}.v-data-table.action-header>div>table>thead>tr{height:65px}tbody tr:nth-of-type(2n+2){background-color:rgba(0,0,0,.05)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
